import axios from 'axios';
import { toChecksumAddress } from 'ethereum-checksum-address';
import config from '@/config/config.js';
import {
    addProject,
    updateProjectArtistAddress,
    ProjectDetails,
    ProjectTokenInfo,
    updateProjectName,
    updateProjectArtistName,
    updateProjectDescription,
    updateProjectWebsite,
    updateProjectLicense,
    updateProjectMaxInvocations,
    updateProjectPricePerTokenInWei,
    addProjectScript,
    updateProjectScript,
    projectScriptByIndex,
    ProjectStatus,
    toggleProjectPaused,
    toggleProjectActive,
    updateProjectBaseURI,
    projectURIInfo,
    toggleProjectPassportMint,
    updateProjectPassportProjectId,
} from '../GenArt';


// const baseUrl = 'http://59.110.68.178:8004';
const adminUrl = ''; //config.adminRequestBaseUrl;
const artistUrl = ''; //config.artistRequestBaseUrl;

const baseApi = async({ method, url, data }) => {
    let result;
    if (method === 'POST') {
        result = await axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'accept': 'application/json'
            }
        });
    } else {
        result = await axios.get(url);
    }

    if (result.status === 200) {
        return 'data' in result ? result.data : result;
    }

};

export const createProject = async(params) => {
    const data = await baseApi({
        method: 'POST',
        url: `/api/audit/addProject`,
        data: params
    });

    return data;
};

export const fetchAuditList = async() => {
    const res = await baseApi({
        method: 'GET',
        url: `${adminUrl}/api/audit/listProjects?pageNum=1&showNum=100`
    });

    return res.data.ntf_projects.map(item => ({
        createdAt: item.CreatedAt,
        deletedAt: item.DeletedAt,
        id: item.ID,
        updatedAt: item.UpdatedAt,
        iscode: item.iscode,
        projectArtist: item.project_artist,
        projectArtistAddress: item.project_artist_address,
        projectBaseURI: item.project_base_uri,
        projectdescription: item.project_description,
        projectLicense: item.project_license,
        projectMintPrice: item.project_mint_price,
        projectName: item.project_name,
        projectWebsite: item.project_website,
    }));
};

/**
 * 添加项目
 *
 * */
export const fetchAddArtProject = async({ web3, library, account, chainID, projectName, projectArtistAddress, projectMintPrice, iscode }) => {
    const pricePerTokenInWei = web3.utils.toWei(projectMintPrice.toString());
    const params = {
        library,
        account,
        chainID,
        projectName,
        artistAddress: projectArtistAddress,
        pricePerTokenInWei,
        iscode: !!iscode,
    };
    return await addProject(params);
};


/**
 * 绑定艺术家地址
 *
 * */
export const fetchbindArtAddress = async({ web3, library, account, chainID, nextProjectID, projectArtistAddress }) => {
    const projectId = nextProjectID.toString();

    const params = {
        library,
        account,
        chainID,
        projectId,
        artistAddress: projectArtistAddress,
    };
    return await updateProjectArtistAddress(params);
};

/**
 * 查询会员卡项目
 * */

export const fetchVipList = async () => {
  const res = await baseApi({
    method: 'GET',
    url: `${artistUrl}/api/audit/listProjects?vip=true`
  });
  return res.data.ntf_projects;
};

/**
 * 启用会员卡项目
 * */

export const fetchEnableProjectToVip = async ({library, account, chainID, projectId}) => {
  const res = await toggleProjectPassportMint({library, account, chainID, projectId: projectId.toString()});
  return res;
};

/**
 * 将项目绑定到会员卡项目
 * */
export const fetchBindProjectToVip = async ({library, account, chainID, projectId, passportProjectId}) => {
  console.log(library, account, chainID, projectId, passportProjectId, 555);
  const res = await updateProjectPassportProjectId({library, account, chainID, projectId, passportProjectId});
  return res;
};

/**
 * 已上链列表
 * */

export const fetchProjectList = async({ web3, library, account, chainID, all }) => {

  const res = await baseApi({
    method: 'GET',
    url: `${artistUrl}/api/listProjects?pageNum=1&showNum=100${all ? '' : `&artistAddress=${account}`}`
  });

  const { projects } = res.data;
  const laods = [];
  projects.forEach(p => {
    const projectId = p.project_id.toString();
    laods.push(ProjectDetails({library, account, chainID, projectId}));
  });
  let projectsData = await Promise.all(laods);

  const tokenInfoLaods = [];
  projects.forEach(p => {
    const projectId = p.project_id.toString();
    tokenInfoLaods.push(ProjectTokenInfo({library, account, chainID, projectId}));
  });
  const tokenInfoData = await Promise.all(tokenInfoLaods);

  // const scriptInfoLaods = [];
  // projects.forEach(p => {
  //   const projectId = p.project_id.toString();
  //   scriptInfoLaods.push(ProjectScriptInfo({library, account, chainID, projectId}));
  // });
  // const scriptInfoData = await Promise.all(scriptInfoLaods);


  projectsData = projectsData.map((row, index) => {
    const [projectName, artist, description, website, license, dynamic] = row;
    const tokenInfo = tokenInfoData[index];
    // const scriptInfo = scriptInfoData[index];
    // console.log(row, tokenInfo, scriptInfo);
    const project = projects[index];

    return {
      ...project,
      projectName,
      artist,
      description,
      website,
      license,
      dynamic,
      active: tokenInfo[4],
      // paused: scriptInfo[5],
      // locked: scriptInfo[4],
    };
  });

  return projectsData;
};


/**
 * fetchProjectNameSave
 * */

/**
 * 更新Project Name
 *
 * */
export const fetchUpdateProjectContent = async ({web3, library, account, chainID, projectId, type, content}) => {
  const commonParams = {
    library,
    account,
    chainID,
    projectId,
  };

  let reuslt;
  switch (type) {
    case 'projectName':
      reuslt = await updateProjectName({
        ...commonParams,
        projectName: content.toString(),
      });
      break;
    case 'projectArtistName':
      reuslt = await updateProjectArtistName({
        ...commonParams,
        projectArtistName: content.toString(),
      });
      break;
    case 'projectDescription':
      reuslt = await updateProjectDescription({
        ...commonParams,
        projectDescription: content.toString(),
      });
      break;
    case 'projectWebsite':
      reuslt = await updateProjectWebsite({
        ...commonParams,
        projectWebsite: content.toString(),
      });
      break;
    case 'projectLicense':
      reuslt = await updateProjectLicense({
        ...commonParams,
        projectLicense: content.toString(),
      });
      break;
    case 'maxInvocations':
      reuslt = await updateProjectMaxInvocations({
        ...commonParams,
        maxInvocations: content.toString(),
      });
      break;
    case 'mintPrice':
      reuslt = await updateProjectPricePerTokenInWei({
        ...commonParams,
        pricePerTokenInWei: web3.utils.toWei(content.toString()),
      });
      break;
  }

  return reuslt;
};

/**
 * 上传Script到链
 *
 * */
export const fetchSaveProjectScript = async ({web3, library, account, chainID, projectId, tokenId, scriptContent, scriptId, type}) => {

  const params = {
    library,
    account,
    chainID,
    projectId,
    script: scriptContent,
  };
  let result;
  // if(type === 'add') {
    result = await axios.post('/api/audit/uploadCode', {
      request: {
        address: tokenId,
        project_id: projectId,
        code: scriptContent,
      },
      signature: 'test-sign'
    });
    // result = await addProjectScript(params);

  // } else {
  //   result = await updateProjectScript({
  //     ...params,
  //     scriptId,
  //   });
  // }
  return result.data;
};

/**
 * 获取链上的Script
 *
 * */
export const fetchProjectScript = async ({web3, library, account, chainID, projectId, index}) => {
  const params = {
    library,
    account,
    chainID,
    projectId,
    index,
  };
  return await projectScriptByIndex(params);
};


/**
 * 获取链上的script info
 *
 * */
export const fetchScriptInfo = async ({web3, library, account, chainID, projectId}) => {
  const result = await axios.get(`/api/audit/getCode/${projectId}`);
  return result.data.data;

  // const params = {
  //   library,
  //   account,
  //   chainID,
  //   projectId,
  // };
  // return await ProjectScriptInfo(params);
};

/**
 * Project Active
 *
 * */
export const fetchProjectActive = async ({web3, library, account, chainID, projectId}) => {
  const params = {
    library,
    account,
    chainID,
    projectId,
  };
  return await toggleProjectActive(params);
};

export const updateProjectbaseURI = async ({web3, library, account, chainID, projectId}) => {
  const params = {
    library,
    account,
    chainID,
    projectId,
  };
  return await updateProjectBaseURI(params);
};

/**
 * Project Paused
 *
 * */
export const fetchProjectPaused = async ({web3, library, account, chainID, projectId}) => {
  const params = {
    library,
    account,
    chainID,
    projectId,
  };
  return await toggleProjectPaused(params);
};

/**
 * 获取某个项目的详情
 *
 * */
export const fetchProjectDetail = async ({web3, library, account, chainID, projectId}) => {
  const params = {
    library,
    account,
    chainID,
    projectId,
  };
  const projectDetail =  await ProjectDetails(params);
  const tokenInfo = await ProjectTokenInfo(params);
  // const URIInfo = await projectURIInfo(params);
  const StatusInfo = await ProjectStatus(params);
  const paused = StatusInfo.paused;
  const locked = StatusInfo.locked;

  const [projectName, artist, description, website, license, dynamic] = projectDetail;
  const [artistAddress, pricePerTokenInWei, invocations, maxInvocations, active, additionalPayee, additionalPayeePercentage] = tokenInfo;

  // const [projectBaseURI, projectBaseIpfsURI, useIpfs] = URIInfo;
  return {
    projectName,
    artist,
    description,
    website,
    license,
    dynamic,
    artistAddress,
    pricePerTokenInWei: web3.utils.fromWei(pricePerTokenInWei.toString()),
    invocations,
    maxInvocations,
    active,
    additionalPayee,
    additionalPayeePercentage,
    // projectBaseURI,
    paused,
    locked
  };
};

/**
 *
 * 更新用户信息
 *
 *
 * */

export const fetchUpdateProfile = async(params) => {
  const res = await baseApi({
    method: 'POST',
    url: `${adminUrl}/api/member/updateProfile`,
    data: params
  });

  return res;
};
